import { CommonModule } from '@angular/common';
import { Component, ViewEncapsulation, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { FormButtonComponent } from 'Shared/app/components/wfs-form-button/form-button.component';

export interface ConfirmModalData {
  title?: string;
  message?: string;
  subMessage?: string;
  confirmText?: string;
  denyText?: string;
  buttonStyles?: { confirm?: string; deny?: string };
  revertButtons?: boolean;
}

@Component({
  selector: 'wfs-new-confirm-modal',
  templateUrl: './new-confirm-modal.component.html',
  styleUrls: ['./new-confirm-modal.component.scss'],
  imports: [CommonModule, FormButtonComponent, MatDialogModule],
  encapsulation: ViewEncapsulation.None // makes styling applicable globally but only for this component
})
/**
 *
 * Created for usage in patientöversikten.
 *
 */
export class NewConfirmModalComponent {
  readonly data = inject<ConfirmModalData>(MAT_DIALOG_DATA);
  readonly #dialogRef = inject(MatDialogRef);

  readonly revertButtons = this.data.revertButtons ?? false;

  triggerEvent(value: boolean): void {
    this.#dialogRef.close(value);
  }
}
